import { ReactNode } from 'react';
import { MinimalBackground } from '@/components/three';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <MinimalBackground>
      <div className="min-h-screen flex">
        <div className="hidden lg:flex lg:w-1/2 items-center justify-center p-12 relative overflow-hidden">
          {/* Glassmorphism panel */}
          <div
            className="absolute inset-4 rounded-3xl"
            style={{
              backgroundColor: 'rgba(0,0,0,0.6)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(91,58,58,0.15)',
            }}
          />

          <div className="relative z-10 max-w-lg text-center">
            {/* Logo */}
            <div className="w-28 h-28 mx-auto mb-8 rounded-2xl border-2 border-white bg-black flex items-center justify-center overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <img src="/wolfromulus.png" alt="Romulus" className="w-24 h-24 object-contain" />
            </div>

            <h1
              className="text-5xl font-bold text-white mb-4 font-roman tracking-[0.2em]"
              style={{ textShadow: '0 0 40px rgba(91,58,58,0.4)' }}
            >
              ROMVLVS
            </h1>
            <p className="text-lg text-gray-300 leading-relaxed">
              Generate stunning websites for local businesses in minutes using AI.
              Scrape leads, create sites, and grow your agency effortlessly.
            </p>

            <div className="mt-12 grid grid-cols-3 gap-6">
              {[
                { value: '50+', label: 'Templates' },
                { value: 'AI', label: 'Powered' },
                { value: '1-Click', label: 'Publish' },
              ].map((stat, i) => (
                <div
                  key={i}
                  className="p-4 text-center rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm transform hover:scale-105 transition-transform"
                  style={{
                    animation: `fadeIn 0.5s ease-out ${i * 0.1}s both`,
                  }}
                >
                  <p className="text-2xl font-bold text-primary-400 font-display">{stat.value}</p>
                  <p className="text-xs text-gray-400 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center p-6 lg:p-12">
          <div className="w-full max-w-md">
            <div className="lg:hidden flex items-center gap-3 mb-8 justify-center">
              <div
                className="w-20 h-20 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center overflow-hidden"
                style={{ boxShadow: '0 0 30px rgba(91,58,58,0.3)' }}
              >
                <img src="/wolfromulus.png" alt="Romulus" className="w-16 h-16 object-contain" />
              </div>
              <h1 className="text-2xl font-bold text-white font-roman tracking-widest">ROMVLVS</h1>
            </div>
            {/* Auth form card */}
            <div
              className="p-8 rounded-2xl"
              style={{
                backgroundColor: 'rgba(0,0,0,0.7)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(91,58,58,0.15)',
              }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </MinimalBackground>
  );
}
